import React, {useLayoutEffect, useEffect, useState} from 'react';
// Queue behind permission, profile, report and other modal dialogs.
const hasModal = () => [...document.querySelectorAll('[aria-modal="true"]')].some(element => getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
export default function SocialAlert({alert, onOpen, onDismiss, onShown}) {
  const [modalOpen, setModalOpen] = useState(hasModal);
  useLayoutEffect(() => {
    const check = () => setModalOpen(hasModal());
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-modal', 'style', 'class']});
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!alert || modalOpen || !onShown) return;
    // Do not persist an unseen notification while a permission dialog is opening.
    const timer = setTimeout(() => { if (!hasModal()) onShown(alert); }, 100);
    return () => clearTimeout(timer);
  }, [alert, modalOpen, onShown]);
  if (!alert || modalOpen) return null;
  return <aside className="social-alert-r9" role="status" aria-live="polite">
    <strong>{alert.requests.length ? 'Arkadaşlık isteğin var' : 'Arkadaşlık isteğin kabul edildi'}</strong>
    {alert.requests.length > 0 && <p>{alert.requests.map(item => item.name).join(', ')} arkadaşın olmak istiyor.</p>}
    {alert.accepted.length > 0 && <p>{alert.accepted.map(item => item.name).join(', ')} ile artık arkadaşsınız.</p>}
    <button type="button" onClick={onOpen}>Arkadaşlara git</button>
    <button type="button" aria-label="Arkadaşlık bildirimini kapat" onClick={onDismiss}>Kapat</button>
  </aside>;
}
